import logoSrc from "../../assets/images/logo.png";

/**
 * Official Doql raster wordmark (flower + wordmark).
 * Collapsed sidebar: left crop shows the flower mark.
 */
export default function SiteLogo({
  tone = "dark",
  layout = "full",
  className = "",
  title = "doql.com",
}) {
  const onDark = tone === "light";

  const mark =
    layout === "symbol" ? (
      <span className="brand-logo-symbol-crop">
        <img src={logoSrc} alt="" aria-hidden />
      </span>
    ) : (
      <img src={logoSrc} alt={title} />
    );

  const body = onDark ? (
    <span className="brand-logo-on-dark">{mark}</span>
  ) : (
    mark
  );

  if (layout === "symbol") {
    return (
      <span
        className={`brand-logo-root ${className}`}
        role="img"
        aria-label={title}
      >
        {body}
      </span>
    );
  }

  return <span className={`brand-logo-root ${className}`}>{body}</span>;
}
